export var SynthV3Asset;
(function (SynthV3Asset) {
    SynthV3Asset["SNXUSD"] = "SNXUSD";
})(SynthV3Asset || (SynthV3Asset = {}));
